import * as Yup from 'yup';

export const validationSchema = Yup.object().shape(
    {
        dataSubject: Yup.string()
          .required('Data Subject Area is Required'),
        dataSet: Yup.string().when('dataSubject',{
          is: (dataSubject:string)=> dataSubject==="weather"|| dataSubject==="FireDanger",
          then: Yup.string().required("Data Set is required")
        }),
        dataFormat: Yup.string()
          .required('Data Format is Required'),
        startHour: Yup.string().when('dataTimeIncrements',{
            is: "hourly",
            then: Yup.string().required("Start Hour is required")
          }),
        endHour: Yup.string().when('dataTimeIncrements',{
            is: "hourly",
            then: Yup.string().required("End Hour is required")
          }),
        startDate: Yup.string().when('dataSubject',{
            is: (dataSubject:string)=> dataSubject==="weather"|| dataSubject==="fieldSample" || dataSubject==="FireDanger",
            then: Yup.string().required("Start Date is required")
          }),
        endDate: Yup.string().when('dataSubject',{
            is: (dataSubject:string)=> dataSubject==="weather"|| dataSubject==="fieldSample" || dataSubject==="FireDanger",
            then: Yup.string().required("End Date is required")
          }),
        dataTimeIncrements:Yup.string().when('dataSubject',{
            is: (dataSubject:string)=> dataSubject==="weather" || dataSubject==="FireDanger",
            then: Yup.string().required("Date Time Frequency selection is required")
          }),
        dataSelectedStations: Yup.string().when('dataSubject', {
          is: (dataSubject:string)=> dataSubject==="weather"|| dataSubject==="stationMetadata" || dataSubject==="FireDanger",
          then: Yup.string().required('Selected Station(s) are Required')
        }),
        sites: Yup.string().when('dataSubject', {
          is: (dataSubject:string)=> dataSubject==="fieldSample"|| dataSubject==="siteMetadata",
          then: Yup.string().required('Selected Site(s) are Required')
        }),
        fuelModels: Yup.string().when('dataSubject', {
          is: (dataSubject:string)=> dataSubject==="FireDanger",
          then: Yup.string().required('Fuel Model(s) are Required')
        }),
    }
);